// Sections
import Goals from "./sections/Goals";
import Area from "./sections/Area";
import Rationale from "./sections/Rationale";

const About = () => {
  return (
    <>
      <Goals />
      <Rationale />
      <Area />
    </>
  );
};

export default About;
